'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class PasswordRecoveryPage extends _react.Component {
  state = {
    status_messages: {}
  };
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  requestPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/user/recover-password', {
      login: state.login
    }).then(function (xhr, response) {
      component.setState({
        info: 'Un e-mail comportant un lien pour créer votre ' + 'nouveau mot de passe vous a été envoyé par e-mail.'
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const message = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let submit;
    if (!state.info) {
      submit = /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: component.requestPassword
      }, "Valider", loader));
    }
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, props, /*#__PURE__*/_react.default.createElement("div", {
      className: "password-recovery-page"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content",
      style: {
        width: '450px',
        maxWidth: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-text-center u-margin-bottom-30"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "auth-logo-link",
      href: (0, _Routes.URL)('Home', _Routes.front_urls)
    }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    }))), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['login'],
      name: "login",
      label: "E-mail de connexion",
      status: state.status_messages
    }), message, submit)));
    return output;
  }
}
exports.default = PasswordRecoveryPage;
